import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import "./NewHeader.css";
import { useHistory } from "react-router-dom";
import ServiceStore from "../../utils/ServiceStore";
import axios from "axios";
import { toast } from "react-toastify";
import fuzzysort from "fuzzysort";
import { useRef } from "react";

const imageurl = "https://api.puneri.foxberry.link/";


function NewHeader() {
  const [url, setUrl] = useState(null);
  const [show, setshow] = useState(false);
  const [auth, setauth] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [user, setUser] = useState();
  const location = useLocation();
  const history = useHistory();
  const [filteredDatalist, setFilteredDatalist] = React.useState([]);
  const [filteredDatalistForum, setFilteredDatalistForum] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const RequestListSearchKeys = ["title", "username"];
  const [blogs, setblogs] = React.useState([]);
  const [conservationtopiclist, setconservationtopiclist] = React.useState([]);
  const searchRef = useRef(null);
  const [isSearchBoxOpen, setSearchBoxOpen] = useState(false);
  const [token, setToken] = React.useState();
  const [NotificationCount, setNotificationCount] = useState([]);

  const localSTorageData = JSON.parse(sessionStorage.getItem("items"));

  useEffect(() => {
    // console.log("location",location)
    
      new ServiceStore().GetAllData("survey/English/Todaysurveylist").then((res) => {
      
        // console.log("Todaysurveylist:::::::::::::::::::: ", res.data);
        setNotificationCount(res.data);
      })
   
  }, []);

  const debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  const getAlldataFileBlog = () => {
    new ServiceStore().GetAllData("writeblogtopic/English").then((res) => {
      res.data.filter((data) => {
        data.updatedAt = data.updatedAt
          .split("T")[0]
          .split("-")
          .reverse()
          .join("/");
      });
      setblogs(res.data);
    })
  }

  const getAlldataFileCommunityForum = () => {
    new ServiceStore().GetAllData("conservationtopic/English").then((res) => {
      res.data.filter((data) => {
        data.updatedAt = data.updatedAt
          .split("T")[0]
          .split("-")
          .reverse()
          .join("/");
      });
      setconservationtopiclist(res.data);
    })
  }

  // const resetForm = () => {
  //   searchRef.current.value = "";
  //   setSearch("");
  //   setController({ ...initialController });
  // };

  // const debounceSearch = debounce((query) => setSearch(query), 200);
  const handleSearch = (e) => {
    setSearch(e.target?.value)

    if (e.target.value.trim() === "" || e.target.value.length === 0) {
      setSearchBoxOpen(false);
    } else {
      setSearchBoxOpen(true);
      const searchResults = fuzzysort
        .go(search, blogs, { keys: RequestListSearchKeys })
        ?.map((result) => result?.obj)
        ?.filter((e) => e);

      setFilteredDatalist([...searchResults]);

      const searchResults1 = fuzzysort
        .go(search, conservationtopiclist, { keys: RequestListSearchKeys })
        ?.map((result) => result?.obj)
        ?.filter((e) => e);

      setFilteredDatalistForum([...searchResults1]);
    }
  };

  const closeSearchBox = () => {
    setSearchBoxOpen(!isSearchBoxOpen)
  }
  useEffect(() => {
    if(location.pathname){
      setUrl(location.pathname);
    }
   
  }, [location]);
  useEffect(() => {
    sessionStorage.setItem("selectedLanguage", "english");
   
    const localSTorageData = JSON.parse(sessionStorage.getItem("items"));
    const auth = JSON.parse(sessionStorage.getItem("items"));
    const token = sessionStorage.getItem("token");

    setToken(token);
    // if (auth) {
    //   setauth(auth)
    //   setshow(true)
    // }
    if (token) {
      setauth(auth);
      setshow(true);
    } else {
      setshow(false);
    }

    const methods = "/user";
    new ServiceStore().GetAllData(methods).then((res) => {
      res.data.filter((data) => {
        if (localSTorageData) {
          if (localSTorageData._id === data._id) {
            setUser(data);
          }
        }
      });
    });

    getAlldataFileBlog();
    getAlldataFileCommunityForum();
    if (localSTorageData) {
      const body = {
        "page": "1",
        "limit": "10"
      }
      new ServiceStore()
        .InsertData(`/announcement/list`, body)
        .then((res) => {
          setAnnouncements(res.response.data.rows)
          // if (res.response.data) {
          //   if (res.response.data.count > 0) {
          //     let array = [];
          //     res.response.data.rows.map((item, index) => {
          //       console.log(`${index} : ${item}`);
          //       array.push(item);
          //     });     
          //     console.log("array : ", array);
          //     setNotifications(array);
          //   } else {
          //     console.log("Announcement deleted");
          //     setAnnouncements();
          //   }
          // } else {
          //   setAnnouncements();
          // }
        });
    }
  
    if (localSTorageData) {
      new ServiceStore()
        .GetAllData(`notification/${localSTorageData._id}`)
        .then((res) => {
          if (res.data) {
            if (res.data.count > 0) {
              let array = [];
              res.data.list[0].notifications.map((item, index) => {
                array.push(item);
              });
              setNotifications(array);
            }
          } else {
            setNotifications();
          }
        });
    }
  }, []);

  // useEffect(() => {
  //   const auth = JSON.parse(sessionStorage.getItem("items"));
  //   const token = sessionStorage.getItem("token");
  //   setToken(token);
  //   // if (auth) {
  //   //   setauth(auth)
  //   //   setshow(true)
  //   // }
  //   if (token) {
  //     setauth(auth);
  //     setshow(true);
  //   } else {
  //     setshow(false);
  //   }
  // }, []);

  // React.useEffect(() => {
  //   console.log("search :", search)
  //   if (search.trim()==="" || search.length === 0) {
  //     setSearchBoxOpen(isSearchBoxOpen);
  //   } else {
  //     setSearchBoxOpen(!isSearchBoxOpen);
  //   }
  //   if (search?.trim()) {
  //     const searchResults = fuzzysort
  //       .go(search, blogs, { keys: RequestListSearchKeys })
  //       ?.map((result) => result?.obj)
  //       ?.filter((e) => e);

  //     setFilteredDatalist([...searchResults]);
  //   }
  //   console.log("blogsArray :", blogs);

  // }, [search, blogs]);

  // React.useEffect(() => {
  //   console.log("search :", search)
  //   if (search.trim()==="" || search.length === 0) {
  //     setSearchBoxOpen(isSearchBoxOpen);
  //   } else {
  //     setSearchBoxOpen(!isSearchBoxOpen);
  //   }
  //   if (search?.trim()) {
  //     const searchResults = fuzzysort
  //       .go(search, conservationtopiclist, { keys: RequestListSearchKeys })
  //       ?.map((result) => result?.obj)
  //       ?.filter((e) => e);

  //     setFilteredDatalistForum([...searchResults]);
  //   }
  //   console.log("conservationtopiclist :", conservationtopiclist);
  // }, [search, conservationtopiclist]);


  const Editdata = (item) => {
    history.push({
      pathname: "/English/BlogD",
      // search: "?id=" + item.id,
      state: item,
    });
  };


  const Editdataforum = (index, e) => {
    // history.push("/demo1/home");
    if (token) {
      history.push({
        pathname: "/English/ForumBlog",
        search: "?id=" + index.id,
        state: index,
      });
    } else {
      alert("Please login!");
    }
  };

  //clear localstorage after remove tab
  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     const handleBeforeUnload = () => {
  //       sessionStorage.removeItem('token'); // Remove the specific data from localStorage
  //     };

  //     window.addEventListener('beforeunload', handleBeforeUnload);

  //     return () => {
  //       window.removeEventListener('beforeunload', handleBeforeUnload);
  //     };
  //     // Perform any other actions or state updates here
  //   }, 10000);

  //   // Clean up the timeout when the component is unmounted
  //   return () => clearTimeout(timeoutId);
  // }, []);

  const Open = (language) => {
    sessionStorage.setItem("selectedLanguage", language);
    //  history.push({pathname:"/Marathi/" + url.split("/")[2]});
  };

  const Logout = () => {
    sessionStorage.removeItem("items");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("selectedLanguage");
    sessionStorage.removeItem("activeTab");
    sessionStorage.removeItem("verifyMobileOTP");
    sessionStorage.removeItem("verifyEmailOTP");
    history.push("/LogIn");
  };
  //   const [toggle, setToggle] = useState(false);
  //   const Collapse = () => {
  //     if (!toggle) {
  //       setToggle(!toggle);
  //     } else {
  //       setToggle(!toggle);
  //     }
  //   };
  // const handleLanguageChange = (e) => {
  //   const selectedLanguage = e.target.value;
  //   setSelectedLanguage(selectedLanguage);
  //   sessionStorage.setItem('selectedLanguage', selectedLanguage);
  // };
  const handleLanguageChange = (language) => {
    sessionStorage.setItem("selectedLanguage", language);
  };
  const handleEventRoute = () => {
    window.open("https://puneri.foxberry.link/English/Home", "_blank");
  };

  // const handleNotificationAlert = () => {
  //   if (!notifications) {
  //     toast.warn("You don't have notifications !", {
  //       position: "top-right",
  //       autoClose: 3000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   }
  // };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light  ">
        <div className="container-fluid">
          <div className="logo nh-logo">
            <Link to="/">
              <img src="../../images/logo.png" className="nh-img" />
            </Link>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse row active-class"
            id="navbarSupportedContent"
          >
            <div>
              {/* <div className="btn-group btn-color">
              <button
                type="button"
                className="btn dropdown-toggle btn-text-col"
                data-bs-toggle="dropdown"
                aria-expanded="true"
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_105_43)">
                    <path
                      d="M14.8959 12.4799C15.6144 11.2428 15.993 9.87 15.993 8.49646C15.993 4.09314 12.3993 0.5 7.99646 0.5C3.59314 0.5 0 4.09375 0 8.49646C0 12.8999 3.59375 16.493 7.99646 16.493C9.43799 16.493 10.8661 16.0813 12.1405 15.3004L16 16.4896L14.8959 12.4799ZM12.0013 14.277C10.7832 15.0677 9.53381 15.5559 7.99646 15.5559C4.10388 15.5559 0.937134 12.3892 0.937134 8.49646C0.937134 4.60388 4.10388 1.43713 7.99646 1.43713C11.8892 1.43713 15.0559 4.60388 15.0559 8.49646C15.0559 9.97559 14.5956 11.1824 13.8854 12.3397L14.6429 15.0909L12.0013 14.277Z"
                      fill="white"
                    />
                    <path
                      d="M8.0376 3.34363C8.02393 3.34314 8.01025 3.34253 7.99646 3.34253C7.9917 3.34253 7.98694 3.34277 7.98218 3.3429C7.97229 3.34277 7.96252 3.34253 7.95264 3.34253C5.11072 3.34253 2.79858 5.65454 2.79858 8.49646C2.79858 11.3384 5.11072 13.6505 7.95264 13.6505C7.96252 13.6505 7.97229 13.6503 7.98218 13.6501C7.98694 13.6503 7.9917 13.6505 7.99646 13.6505C8.01025 13.6505 8.02393 13.6499 8.0376 13.6494C10.8405 13.6039 13.1066 11.3101 13.1066 8.49646C13.1066 5.68298 10.8405 3.38916 8.0376 3.34363ZM11.7294 6.62231H10.1902C10.0916 6.02844 9.94543 5.48108 9.75684 5.0094C9.69922 4.86536 9.63794 4.73022 9.57361 4.60376C10.5114 4.99573 11.2783 5.71704 11.7294 6.62231ZM12.1696 8.49646C12.1696 8.81848 12.1331 9.13208 12.0645 9.43359H10.3031C10.3269 9.12756 10.3392 8.81421 10.3392 8.49646C10.3392 8.17883 10.3269 7.86548 10.3031 7.55945H12.0645C12.1331 7.86096 12.1696 8.17456 12.1696 8.49646ZM8.01294 12.7126C8.00427 12.7128 7.99573 12.7129 7.98718 12.713C7.70984 12.7037 7.36523 12.2831 7.10632 11.6356C6.95789 11.2646 6.83948 10.8304 6.75366 10.3645H9.23938C9.15356 10.8304 9.03516 11.2646 8.88672 11.6356C8.62988 12.2777 8.28894 12.6967 8.01294 12.7126ZM6.63 9.43359C6.60437 9.12939 6.59082 8.81592 6.59082 8.49646C6.59082 8.17712 6.60437 7.86365 6.63 7.55945H9.36304C9.38867 7.86365 9.4021 8.17712 9.4021 8.49646C9.4021 8.81592 9.38867 9.12939 9.36304 9.43359H6.63ZM3.73572 8.49646C3.73572 8.17456 3.77209 7.85461 3.84082 7.55322H5.69006C5.66626 7.85925 5.65381 8.17883 5.65381 8.49646C5.65381 8.81421 5.66626 9.12756 5.69006 9.43359H3.84082C3.77209 9.13208 3.73572 8.81848 3.73572 8.49646ZM7.98718 4.28003C7.99573 4.28015 8.00427 4.28027 8.01294 4.2804C8.28894 4.29639 8.62988 4.71533 8.88672 5.35742C9.03516 5.72839 9.15356 6.15637 9.23938 6.62231H6.75366C6.83948 6.15637 6.95789 5.72839 7.10632 5.35742C7.36523 4.70996 7.70984 4.28931 7.98718 4.28003ZM6.44226 4.55945C6.36951 4.69849 6.30066 4.84839 6.23621 5.0094C6.04761 5.48108 5.90161 6.02844 5.80286 6.62231H4.1759C4.64453 5.68176 5.45422 4.93982 6.44226 4.55945ZM4.17578 10.3707H5.80286C5.90149 10.9646 6.04761 11.512 6.23621 11.9836C6.30066 12.1447 6.36951 12.2946 6.44226 12.4336C5.45422 12.0532 4.64453 11.3114 4.17578 10.3707ZM9.57361 12.3893C9.63794 12.2628 9.69922 12.1277 9.75684 11.9836C9.94543 11.512 10.0914 10.9584 10.1902 10.3645H11.7294C11.2783 11.2698 10.5114 11.9973 9.57361 12.3893Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_105_43">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                English
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item" href="#">
                    Marathi
                  </a>
                </li>
              </ul>
            </div> */}

              {/* <div className="collapse navbar-collapse img-pro" id="navbar-list-4">
    <ul className="navbar-nav">
        <li className="nav-item ">
        <a className="nav-link dropdown-toggle img-profile-padding notification-icon" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src="../../images/blog-icon.png" width="40" height="40" className="rounded-circle"/>
          <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.50254 5.6559L2.01317 1.16673C1.88985 1.04312 1.72498 0.975121 1.54917 0.975121C1.37327 0.975121 1.20849 1.04312 1.08498 1.16673L0.691805 1.5601C0.568098 1.68351 0.5 1.84849 0.5 2.02429C0.5 2.2001 0.568098 2.36488 0.691805 2.48839L6.03678 7.83346C6.16068 7.95746 6.32624 8.02536 6.50224 8.02488C6.67902 8.02536 6.84439 7.95756 6.96839 7.83346L12.3082 2.49337C12.4319 2.36985 12.5 2.20507 12.5 2.02917C12.5 1.85337 12.4319 1.68858 12.3082 1.56498L11.915 1.17171C11.6591 0.915804 11.2425 0.915804 10.9867 1.17171L6.50254 5.6559Z" fill="#0A0A13"/>
</svg>
        </a>
        <div className="dropdown-menu header-drop-menu" aria-labelledby="navbarDropdownMenuLink">
          <a className="dropdown-item" href="#">Account Setting</a>
          <a className="dropdown-item" href="#">Dashboard</a>
          <a className="dropdown-item" href="#" style={{color:"red"}}>Log Out</a>
        </div>
      </li>   
    </ul>
  </div> */}
              <div className="row">
                <div className="col-md-10 d-flex justify-content-end">
                  <div className="col-md-6" style={{ display: 'flex' }}>
                    <input

                      className="form-control"
                      placeholder="Search..."
                      onChange={handleSearch}
                      // onBlur={closeSearchBox}
                      style={{
                        borderRadius: isSearchBoxOpen ? '10px 10px 10px 10px' : '10px 10px 10px 10px',
                      }}
                    />
                    {/* <input className="form-control headerSearchButton" type="button" value="Search" onclick={handleSearchnew} /> */}
                  </div>
                  {isSearchBoxOpen && (
                    <div
                      className="form-control"
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        width: '100%',
                        background: 'white',
                        border: '1px solid #ccc',
                        zIndex: 10,
                        height: 'max-content'
                      }}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <h2>Blogs</h2>
                          {filteredDatalist?.length > 0 ? (
                            <div className="row" style={{ display: 'grid' }}>
                              {filteredDatalist?.map((item) => (
                                <div className="col-md-6 mb-4">
                                  <div className="card border-0">
                                    <div className="card-body" style={{ cursor: 'pointer' }} onClick={() => Editdata(item)}>
                                      <h4 className="card-title">{item.title}</h4>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p>No items to display.</p>
                          )}

                        </div>

                        <div className="col-md-6">
                          <h2>Community Forum</h2>
                          {filteredDatalistForum?.length > 0 ? (
                            <div className="row" style={{ display: 'grid' }}>
                              {filteredDatalistForum?.map((item) => (
                                <div className="col-md-6 mb-4">
                                  <div className="card border-0">
                                    <div className="card-body" style={{ cursor: 'pointer' }} onClick={() => Editdataforum(item)}>
                                      <h4 className="card-title">{item.title}</h4>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p>No items to display.</p>
                          )}

                        </div>
                      </div>
                    </div>
                  )}
                </div>



                <div className="col-md-2 align-self-center">
                  <div className="dropdown1 dropdown-btn-lang">
                    <button
                      className="btn btn-language dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                    >
                      <svg
                        className="svg-btn"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_273_232)">
                          <path
                            d="M14.8959 12.4799C15.6144 11.2428 15.993 9.87 15.993 8.49646C15.993 4.09314 12.3993 0.5 7.99646 0.5C3.59314 0.5 0 4.09375 0 8.49646C0 12.8999 3.59375 16.493 7.99646 16.493C9.43799 16.493 10.8661 16.0813 12.1405 15.3004L16 16.4896L14.8959 12.4799ZM12.0013 14.277C10.7832 15.0677 9.53381 15.5559 7.99646 15.5559C4.10388 15.5559 0.937134 12.3892 0.937134 8.49646C0.937134 4.60388 4.10388 1.43713 7.99646 1.43713C11.8892 1.43713 15.0559 4.60388 15.0559 8.49646C15.0559 9.97559 14.5956 11.1824 13.8854 12.3397L14.6429 15.0909L12.0013 14.277Z"
                            fill="white"
                          />
                          <path
                            d="M8.03784 3.34363C8.02417 3.34314 8.0105 3.34253 7.9967 3.34253C7.99194 3.34253 7.98718 3.34277 7.98242 3.3429C7.97253 3.34277 7.96277 3.34253 7.95288 3.34253C5.11096 3.34253 2.79883 5.65454 2.79883 8.49646C2.79883 11.3384 5.11096 13.6505 7.95288 13.6505C7.96277 13.6505 7.97253 13.6503 7.98242 13.6501C7.98718 13.6503 7.99194 13.6505 7.9967 13.6505C8.0105 13.6505 8.02417 13.6499 8.03784 13.6494C10.8407 13.6039 13.1068 11.3101 13.1068 8.49646C13.1068 5.68298 10.8407 3.38916 8.03784 3.34363ZM11.7296 6.62231H10.1904C10.0918 6.02844 9.94568 5.48108 9.75708 5.0094C9.69946 4.86536 9.63818 4.73022 9.57385 4.60376C10.5116 4.99573 11.2786 5.71704 11.7296 6.62231ZM12.1698 8.49646C12.1698 8.81848 12.1333 9.13208 12.0647 9.43359H10.3033C10.3271 9.12756 10.3395 8.81421 10.3395 8.49646C10.3395 8.17883 10.3271 7.86548 10.3033 7.55945H12.0647C12.1333 7.86096 12.1698 8.17456 12.1698 8.49646ZM8.01318 12.7126C8.00452 12.7128 7.99597 12.7129 7.98743 12.713C7.71008 12.7037 7.36548 12.2831 7.10657 11.6356C6.95813 11.2646 6.83972 10.8304 6.75391 10.3645H9.23962C9.15381 10.8304 9.0354 11.2646 8.88696 11.6356C8.63013 12.2777 8.28918 12.6967 8.01318 12.7126ZM6.63025 9.43359C6.60461 9.12939 6.59106 8.81592 6.59106 8.49646C6.59106 8.17712 6.60461 7.86365 6.63025 7.55945H9.36328C9.38892 7.86365 9.40234 8.17712 9.40234 8.49646C9.40234 8.81592 9.38892 9.12939 9.36328 9.43359H6.63025ZM3.73596 8.49646C3.73596 8.17456 3.77234 7.85461 3.84106 7.55322H5.69031C5.6665 7.85925 5.65405 8.17883 5.65405 8.49646C5.65405 8.81421 5.6665 9.12756 5.69031 9.43359H3.84106C3.77234 9.13208 3.73596 8.81848 3.73596 8.49646ZM7.98743 4.28003C7.99597 4.28015 8.00452 4.28027 8.01318 4.2804C8.28918 4.29639 8.63013 4.71533 8.88696 5.35742C9.0354 5.72839 9.15381 6.15637 9.23962 6.62231H6.75391C6.83972 6.15637 6.95813 5.72839 7.10657 5.35742C7.36548 4.70996 7.71008 4.28931 7.98743 4.28003ZM6.4425 4.55945C6.36975 4.69849 6.3009 4.84839 6.23645 5.0094C6.04785 5.48108 5.90186 6.02844 5.8031 6.62231H4.17615C4.64478 5.68176 5.45447 4.93982 6.4425 4.55945ZM4.17603 10.3707H5.8031C5.90173 10.9646 6.04785 11.512 6.23645 11.9836C6.3009 12.1447 6.36975 12.2946 6.4425 12.4336C5.45447 12.0532 4.64478 11.3114 4.17603 10.3707ZM9.57385 12.3893C9.63818 12.2628 9.69946 12.1277 9.75708 11.9836C9.94568 11.512 10.0917 10.9584 10.1904 10.3645H11.7296C11.2786 11.2698 10.5116 11.9973 9.57385 12.3893Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_273_232">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      Language
                    </button>
                    <ul className="dropdown-menu dropdown-btn-lang-menu">
                      <li>
                        <Link
                          to="/English/Home"
                          onClick={() => handleLanguageChange("english")}
                        >
                          English
                        </Link>
                      </li>
                      <li>
                        <Link to="/Marathi/Home"
                          onClick={() => {
                            Open("marathi");
                          }}
                        >
                          Marathi
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* {show && <li className="nav-item dropdown hedmarker">
                <a
                  className="nav-link dropdown-toggle notification-icon pro-icon"
                  href="#"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src="../../images/blog-icon.png"
                    width="40"
                    height="40"
                    className="rounded-circle"
                  />
                  <svg
                    width="13"
                    height="9"
                    viewBox="0 0 13 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.50254 5.6559L2.01317 1.16673C1.88985 1.04312 1.72498 0.975121 1.54917 0.975121C1.37327 0.975121 1.20849 1.04312 1.08498 1.16673L0.691805 1.5601C0.568098 1.68351 0.5 1.84849 0.5 2.02429C0.5 2.2001 0.568098 2.36488 0.691805 2.48839L6.03678 7.83346C6.16068 7.95746 6.32624 8.02536 6.50224 8.02488C6.67902 8.02536 6.84439 7.95756 6.96839 7.83346L12.3082 2.49337C12.4319 2.36985 12.5 2.20507 12.5 2.02917C12.5 1.85337 12.4319 1.68858 12.3082 1.56498L11.915 1.17171C11.6591 0.915804 11.2425 0.915804 10.9867 1.17171L6.50254 5.6559Z"
                      fill="#0A0A13"
                    />
                  </svg>
                </a>
                <ul className="dropdown-menu pro-icon-font nh-drop-left">
                  <li>
                    <Link to="/English/AccountSetting" className="dropdown-item ">
                      Account Settings
                    </Link>
                  </li>
                  <li>
                    <Link to="/English/Dashboard" className="dropdown-item ">
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => Logout()}
                      className="dropdown-item "
                      style={{ color: "red" }}
                    >
                      Logout
                    </Link>
                  </li>
                </ul>
              </li>} */}
              {/* <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle eng-pad" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <img
                  src="../../images/blog-icon.png"
                  width="40"
                  height="40"
                  className="rounded-circle"
                />
                <svg
                  width="13"
                  height="9"
                  viewBox="0 0 13 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.50254 5.6559L2.01317 1.16673C1.88985 1.04312 1.72498 0.975121 1.54917 0.975121C1.37327 0.975121 1.20849 1.04312 1.08498 1.16673L0.691805 1.5601C0.568098 1.68351 0.5 1.84849 0.5 2.02429C0.5 2.2001 0.568098 2.36488 0.691805 2.48839L6.03678 7.83346C6.16068 7.95746 6.32624 8.02536 6.50224 8.02488C6.67902 8.02536 6.84439 7.95756 6.96839 7.83346L12.3082 2.49337C12.4319 2.36985 12.5 2.20507 12.5 2.02917C12.5 1.85337 12.4319 1.68858 12.3082 1.56498L11.915 1.17171C11.6591 0.915804 11.2425 0.915804 10.9867 1.17171L6.50254 5.6559Z"
                    fill="#0A0A13"
                  />
                </svg>
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><Link to='/English/Gallery'><a className="dropdown-item" href="#">Gallery</a></Link></li>
            <li><Link to='/English/Blogs'><a className="dropdown-item" href="#">Blogs</a></Link></li>
            <li><Link to='/English/Forum'><a className="dropdown-item" href="#">Community forum</a></Link></li>
            <li><Link to='/English/Survey'><a className="dropdown-item" href="#">Survey</a></Link></li>
          </ul>
        </li> */}
            </div>

            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ul-alll  ">
              <li className="nav-item">
                <Link to="/English/AboutUs">
                  <a
                    className="nav-link res-menu-middle"
                    aria-current="page"
                    href="#"
                    style={{ marginTop: "5px" }}
                  >
                    About us
                  </a>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="about" to="/English/Facility">
                  <a
                    className="nav-link res-menu-middle"
                    href="#"
                    style={{ marginTop: "5px" }}
                  >
                    Facilites
                  </a>
                </Link>
              </li>
              <li className="nav-item dropdown nh-text-font">
                <a
                  className="nav-link dropdown-toggle eng-pad "
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Engagement
                  <svg
                    className="ghanta-arrow"
                    width="13"
                    height="9"
                    viewBox="0 0 13 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.50254 5.6559L2.01317 1.16673C1.88985 1.04312 1.72498 0.975121 1.54917 0.975121C1.37327 0.975121 1.20849 1.04312 1.08498 1.16673L0.691805 1.5601C0.568098 1.68351 0.5 1.84849 0.5 2.02429C0.5 2.2001 0.568098 2.36488 0.691805 2.48839L6.03678 7.83346C6.16068 7.95746 6.32624 8.02536 6.50224 8.02488C6.67902 8.02536 6.84439 7.95756 6.96839 7.83346L12.3082 2.49337C12.4319 2.36985 12.5 2.20507 12.5 2.02917C12.5 1.85337 12.4319 1.68858 12.3082 1.56498L11.915 1.17171C11.6591 0.915804 11.2425 0.915804 10.9867 1.17171L6.50254 5.6559Z"
                      fill="#0A0A13"
                    />
                  </svg>
                </a>
                <ul
                  className="dropdown-menu nh-eng-drop-res"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <Link to="/English/Gallery">
                      <a className="dropdown-item nh-eng-drop-res" href="#">
                        Gallery
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/English/Blog">
                      <a className="dropdown-item nh-eng-drop-res" href="#">
                        Blogs
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/English/Forum">
                      <a className="dropdown-item nh-eng-drop-res" href="#">
                        Community forum
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link to="/English/Survey">
                      <a className="dropdown-item nh-eng-drop-res" href="#">
                        Survey
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link onClick={handleEventRoute}>
                      <a className="dropdown-item nh-eng-drop-res">Events</a>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="about eng-pad" to="/English/Publication">
                  <a className="nav-link" href="#" aria-disabled="true">
                    Publications
                  </a>
                </Link>
              </li>
              {/* {show && ( */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle nh-notifi"
                  // href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle={`${notifications ? "dropdown" : ""}`}
                  aria-expanded="false"
                // onClick={handleNotificationAlert}
                >
                  {/* <svg
                      width="30"
                      height="31"
                      viewBox="0 0 30 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_954_1588)">
                        <path
                          d="M26.7238 21.6413C24.8338 20.0438 23.75 17.7088 23.75 15.235V11.75C23.75 7.35125 20.4825 3.71 16.25 3.1V1.75C16.25 1.05875 15.69 0.5 15 0.5C14.31 0.5 13.75 1.05875 13.75 1.75V3.1C9.51625 3.71 6.25 7.35125 6.25 11.75V15.235C6.25 17.7088 5.16625 20.0438 3.265 21.6513C2.77875 22.0675 2.5 22.6725 2.5 23.3125C2.5 24.5188 3.48125 25.5 4.6875 25.5H25.3125C26.5188 25.5 27.5 24.5188 27.5 23.3125C27.5 22.6725 27.2213 22.0675 26.7238 21.6413Z"
                          fill="#0A0A13"
                        />
                        <path
                          d="M15.0002 30.5C17.264 30.5 19.1577 28.8863 19.5927 26.75H10.4077C10.8427 28.8863 12.7365 30.5 15.0002 30.5Z"
                          fill="#0A0A13"
                        />
                        {notifications && (
                          <circle
                            cx="21.6668"
                            cy="9.66667"
                            r="5.83333"
                            fill="#AB1C1C"
                          />
                        )}
                      </g>
                      <defs>
                        <clipPath id="clip0_954_1588">
                          <rect
                            width="30"
                            height="30"
                            fill="white"
                            transform="translate(0 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg> */}

                  {/* {notifications && (
                    <Link to="/English/Notifications">
                      <svg fill="#000000" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20,18H4l2-2V10a6,6,0,0,1,5-5.91V3a1,1,0,0,1,2,0V4.09a5.9,5.9,0,0,1,1.3.4A3.992,3.992,0,0,0,18,10v6Zm-8,4a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22ZM18,4a2,2,0,1,0,2,2A2,2,0,0,0,18,4Z" /></svg>
                    </Link>
                  )} */}

                  {(notifications.length == 0 && announcements.length == 0) && (
                    <div>
                    <Link to="/English/Notifications">
                      <svg fill="#000000" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10,20h4a2,2,0,0,1-4,0Zm8-4V10a6,6,0,0,0-5-5.91V3a1,1,0,0,0-2,0V4.09A6,6,0,0,0,6,10v6L4,18H20Z" /></svg>
                    </Link>
                    
                    </div>
                  )}

                </a>
                {/* <ul
                  className="dropdown-menu nh-eng-drop-res"
                  aria-labelledby="navbarDropdown"
                >
                  {notifications &&
                    notifications.map((item, index) => (
                      <>
                        <Link to="/English/Notifications">
                          <svg fill="#000000" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20,18H4l2-2V10a6,6,0,0,1,5-5.91V3a1,1,0,0,1,2,0V4.09a5.9,5.9,0,0,1,1.3.4A3.992,3.992,0,0,0,18,10v6Zm-8,4a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22ZM18,4a2,2,0,1,0,2,2A2,2,0,0,0,18,4Z" /></svg>
                        </Link>
                        <li key={index} onClick={NavigateToDashboard}>
                          <a className="dropdown-item">{item}</a>
                        </li>
                      </>
                    ))}
                </ul> */}
                {(notifications.length > 0 || announcements.length > 0) &&
                 <div>
                  <span style={{"fontSize": "x-large","fontFamily": "cursive","color": "green","marginLeft":"11px"}}>{NotificationCount.count}</span>
                  <Link to="/English/Notifications">
                    <svg fill="#000000" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20,18H4l2-2V10a6,6,0,0,1,5-5.91V3a1,1,0,0,1,2,0V4.09a5.9,5.9,0,0,1,1.3.4A3.992,3.992,0,0,0,18,10v6Zm-8,4a2,2,0,0,0,2-2H10A2,2,0,0,0,12,22ZM18,4a2,2,0,1,0,2,2A2,2,0,0,0,18,4Z" /></svg>
                  </Link>
                  
                  </div>
                }
              </li>
              {/* )} */}
              {show && (
                <li className="nav-item dropdown hedmarker">
                  <a
                    className="nav-link dropdown-toggle notification-icon pro-icon"
                    href="#"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={
                        user?.image
                          ? imageurl + user.image
                          : "../../images/profile4.png"
                      }
                      width="42"
                      height="40"
                      className="rounded-circle"
                    />
                    <svg
                      width="13"
                      height="9"
                      viewBox="0 0 13 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.50254 5.6559L2.01317 1.16673C1.88985 1.04312 1.72498 0.975121 1.54917 0.975121C1.37327 0.975121 1.20849 1.04312 1.08498 1.16673L0.691805 1.5601C0.568098 1.68351 0.5 1.84849 0.5 2.02429C0.5 2.2001 0.568098 2.36488 0.691805 2.48839L6.03678 7.83346C6.16068 7.95746 6.32624 8.02536 6.50224 8.02488C6.67902 8.02536 6.84439 7.95756 6.96839 7.83346L12.3082 2.49337C12.4319 2.36985 12.5 2.20507 12.5 2.02917C12.5 1.85337 12.4319 1.68858 12.3082 1.56498L11.915 1.17171C11.6591 0.915804 11.2425 0.915804 10.9867 1.17171L6.50254 5.6559Z"
                        fill="#0A0A13"
                      />
                    </svg>
                  </a>
                  <ul className="dropdown-menu pro-icon-font nh-drop-left pro-drop-menu">
                    <li>
                      <Link
                        to="/English/AccountSetting"
                        className="dropdown-item "
                      >
                        Account Settings
                      </Link>
                    </li>
                    <li>
                      <Link to="/English/Dashboard" className="dropdown-item ">
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/English/Favourites" className="dropdown-item ">
                        Favourites
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => Logout()}
                        className="dropdown-item "
                        style={{ color: "red" }}
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {!show && (
                <li className="nav-item " style={{ textAlign: "center" }}>
                  <Link className="about" to="/LogIn">
                    <button className="btn btn-login nh-btn-new" type="submit">
                      Login/Sign up
                    </button>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default NewHeader;
